module.exports = __webpack_public_path__ + "img/pethouse19.7dd91a10.jpg";